// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__Rw774","Logo_heading":"Logo_Logo_heading__JPq_H","Logo_asset":"Logo_Logo_asset__TrGUD","Logo_asset___isSmall":"Logo_Logo_asset___isSmall__v_cQA"};